import React from 'react';
import ConfigurationAudioFields from './ConfigurationAudioFields';
import ConfigurationNetworkFields from './ConfigurationNetworkFields';

type ConfigurationFieldsProps = {
  configVersion: number;
  appliedConfigVersion: number | null;
};

const ConfigurationFields: React.FC<ConfigurationFieldsProps> = (props) => {
  const appliedLabel =
    props.appliedConfigVersion == null
      ? 'not applied'
      : `applied v${props.appliedConfigVersion}`;
  const pending =
    props.appliedConfigVersion == null || props.appliedConfigVersion < props.configVersion;

  return (
    <div className="mt-3 pt-2 border-top">
      <div className="d-flex justify-content-between align-items-baseline gap-2 mb-1">
        <div className="fw-semibold">Remote configuration</div>
        <span className="text-muted small">
          Config v{props.configVersion} ({appliedLabel}
          {pending ? ', pending' : ''})
        </span>
      </div>
      <ConfigurationAudioFields />
      <ConfigurationNetworkFields />
    </div>
  );
};

export default ConfigurationFields;
